import { Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface AddFieldMenuProps<T extends string> {
  /** Text of the button, e.g. "Add objective". */
  label: string
  /** The fields not shown yet, each with its label. */
  options: { value: T; label: string }[]
  onAdd: (value: T) => void
}

/**
 * The group counterpart of `OptionalField`: an "add" button whose menu reveals
 * one of several fields kept out of view until they are needed. It renders
 * nothing once every field is shown.
 */
export function AddFieldMenu<T extends string>({ label, options, onAdd }: AddFieldMenuProps<T>) {
  if (options.length === 0) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="ghost" size="sm" className="self-start">
          <Plus className="size-3.5" />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {options.map((option) => (
          <DropdownMenuItem key={option.value} onSelect={() => onAdd(option.value)}>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
